import axios from '../../../../utills/axiosConfig';

export const fetchStoneCuts = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/stone-cuts', { params });
  return res.data;
};

export const addStoneCut = async (stoneCut) => {
  try {
    const res = await axios.post('/stone-cuts', stoneCut);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateStoneCut = async (id, stoneCut) => {
  console.log('API call - Updating stone cut:', id, stoneCut);
  const res = await axios.put(`/stone-cuts/${id}`, stoneCut);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteStoneCut = async (id) => {
  const res = await axios.delete(`/stone-cuts/${id}`);
  return res.data;
};

export const importStoneCutCSV = async (formData) => {
  const { data } = await axios.post('/stone-cuts/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 